import ManagedLookup from '../components/ManagedLookup';
import useLookupPage from '../hooks/useLookupPage';
import fields from './fields';
import columns from './columns';

const LoadZones = ({ definition }) => {
    const page = useLookupPage('load-zones', columns);
    return <ManagedLookup definition={definition} columns={columns} fields={fields} page={page} allowAddAliases />;
};
export default LoadZones;
